import React from 'react';
import styled, { css } from 'styled-components';
import { TypographyComponent as TypographyElement } from '@tvg/fuse-design';
import VisiblyHidden from '../VisiblyHidden';
import { DescriptionProps } from './DescriptionProps';

const Container = styled.div`
  margin-bottom: var(--spacing-space32);
  ${(props) =>
    props.about === 'false' &&
    css`
      border-top: 1px solid var(--color-global-grey400);
      margin-top: var(--spacing-space32);
      padding-top: var(--spacing-space32);
    `}
`;

const DescriptionTitle = styled(TypographyElement)`
  margin-bottom: var(--spacing-space16);
`;

const TextContainer = styled.div`
  max-width: 700px;
`;

const Text = styled.p`
  margin-bottom: var(--spacing-space16);
`;

const Body = styled.div`
  > * {
    font-size: inherit;
    line-height: inherit;
    margin-top: var(--spacing-space16);
  }

  h2 {
    font-weight: bold;
  }

  ul {
    padding: 0 0 0 var(--spacing-space32);
    list-style-type: disc;
  }
`;

function Description({ description, ean = '', itemNumber, useAccordion = false }: DescriptionProps) {
  return (
    <Container about={useAccordion ? 'true' : 'false'} data-testid="description_wrapper_container">
      <TextContainer data-testid="product_description_container">
        {!useAccordion && (
          <DescriptionTitle tag="h2" size="3" data-testid="product_description_header">
            Product description
          </DescriptionTitle>
        )}

        <Text
          dangerouslySetInnerHTML={{
            __html: `<strong>Item number:</strong> ${itemNumber}`,
          }}
          data-testid="product_description_itemNumber"
        />

        {ean && (
          <>
            <Text
              dangerouslySetInnerHTML={{
                __html: `<strong>EAN:</strong> ${ean}`,
              }}
              aria-hidden
              data-testid="product_description_ean"
            />
            <VisiblyHidden
              text={`E.A.N: ${ean.split('').join(' ')}`}
              testId="product_description_ean_accessibilityText"
            />
          </>
        )}

        <Body
          dangerouslySetInnerHTML={{
            __html: description,
          }}
          data-testid="product_description_body"
        />
      </TextContainer>
    </Container>
  );
}

export default Description;
